export default __webpack_public_path__ + "assets/icons/notify2.432dae35.svg";